mutation ConfirmAssetUpload($s3Key: String!, $fileName: String) {
  asset: StreamToolsConfirmAssetUpload(s3Key: $s3Key, fileName: $fileName) {
    assetId
    fileName
    contentType
    sizeBytes
    publicUrl
    createdAt
  }
}
